import {
  types,
  IReadLocalFileAction,
  IReadLocalFileValidationFailureAction,
  IReadLocalFileCancelAction,
  ICloseUploadDialogAction,
  IUploadFileAction,
  IRetrievedTmpLinkAction,
  ISetProgressAction,
  IFailureAction,
  IVerificationSuccessAction,
  IUploadSuccessAction,
  IUploadCanceledAction,
  ICreateOrUpdateEditionAction,
  ICreateOrUpdateEditionSuccessAction,
  IResetFileDataAction,
  IReopenUploadModal,
  IReadLocalFileForPreviewAction,
  IUploadPreviewAction,
  IPreviewVerificationSuccessAction,
  IDeleteUploadedPreviewsAction,
  IDeleteUploadedPreiewsSuccessAction,
  IPreviewPollingSuccessAction,
  SetPreviewFieldType,
  IVerificationPollingSuccessAction,
  IVerificationPollingFailureAction,
  ICreateOrUpdateEditionPollingSuccess,
  OnProgressCallbackType,
} from '../types/file'
import { IEditionMetadata } from '../types/pack'
import { IPollingTaskData } from '../types/polling'

export const readLocalFile = (
  modalId: string,
  fileInstance: File | null,
  groupId: string,
  existingEdition?: IEditionMetadata
): IReadLocalFileAction => ({
  type: types.READ_LOCAL_FILE,
  modalId,
  fileInstance,
  groupId,
  existingEdition,
})

export const readLocalFileValidationFailure = (
  messages?: string[]
): IReadLocalFileValidationFailureAction => ({
  type: types.READ_LOCAL_FILE__VALIDATE_FAILURE,
  messages,
})

export const readLocalFileCancel = (
  message: string
): IReadLocalFileCancelAction => ({
  type: types.READ_LOCAL_FILE__CANCEL,
  message,
})

export const closeUploadDialog = (): ICloseUploadDialogAction => ({
  type: types.CLOSE_UPLOAD_DIALOG,
})

export const uploadFile = (onProgress: OnProgressCallbackType) => (
  modalId: string,
  name: string,
  groupId: string,
  editionsToUpdate: string[]
): IUploadFileAction => ({
  type: types.UPLOAD__STARTED,
  name,
  editionsToUpdate,
  groupId,
  onProgress,
  modalId,
})

export const retrievedTmpLink = (id: string): IRetrievedTmpLinkAction => ({
  type: types.UPLOAD__RETRIEVED_TMP_LINK,
  id,
})

export const setProgress = (progress: number): ISetProgressAction => ({
  type: types.UPLOAD__PROGRESS,
  progress,
})

export const verificationPollingSuccess = (groupId: string) => (
  data: IPollingTaskData
): IVerificationPollingSuccessAction => ({
  type: types.VERIFICATION_POLLING__SUCCESS,
  groupId,
  data,
})

export const verificationPollingFailure = (
  message: string,
  correlationId: string
): IVerificationPollingFailureAction => ({
  type: types.VERIFICATION_POLLING__FAILURE,
  message,
  correlationId,
})

export const verificationSuccess = (): IVerificationSuccessAction => ({
  type: types.VERIFICATION__SUCCESS,
})

export const verificationFailure = (
  message: string,
  correlationId: string,
  disableUploadAndShowCloseButton?: boolean
): IFailureAction => ({
  type: types.VERIFICATION__FAILURE,
  message,
  correlationId,
  disableUploadAndShowCloseButton,
})

export const uploadSuccess = (): IUploadSuccessAction => ({
  type: types.UPLOAD__SUCCESS,
})

export const uploadFailure = (
  message: string,
  correlationId: string
): IFailureAction => ({
  type: types.UPLOAD__FAILURE,
  message,
  correlationId,
})

export const uploadCancel = (
  matchedEdition: IEditionMetadata
): IUploadCanceledAction => ({
  type: types.UPLOAD__CANCELED,
  matchedEdition,
})

export const reopenUploadModal = (modalId: string): IReopenUploadModal => ({
  type: types.REOPEN_UPLOAD_MODAL,
  modalId,
})

export const createOrUpdateEdition = (
  fileId: string
): ICreateOrUpdateEditionAction => ({
  type: types.CREATE_OR_UPDATE_EDITION__STARTED,
  fileId,
})

export const createOrUpdateEditionPollingSuccess = (
  data: IPollingTaskData
): ICreateOrUpdateEditionPollingSuccess => ({
  type: types.CREATE_OR_UPDATE_EDITION_POLLING__SUCCESS,
  data,
})

export const createOrUpdateEditionSuccess = (
  message: string
): ICreateOrUpdateEditionSuccessAction => ({
  type: types.CREATE_OR_UPDATE_EDITION__SUCCESS,
  message,
})

export const createOrUpdateEditionFailure = (
  message: string,
  correlationId: string,
  disableUploadAndShowCloseButton?: boolean
): IFailureAction => ({
  type: types.CREATE_OR_UPDATE_EDITION__FAILURE,
  message,
  correlationId,
  disableUploadAndShowCloseButton,
})

export const resetFileData = (): IResetFileDataAction => ({
  type: types.RESET_FILE_DATA,
})

export const readLocalFileForPreview = (
  modalId: string,
  fileInstance: File | null
): IReadLocalFileForPreviewAction => ({
  type: types.READ_LOCAL_FILE_FOR_PREVIEW,
  modalId,
  fileInstance,
})

export const uploadPreview = (onProgress: OnProgressCallbackType) => (
  modalId: string,
  setPreviewField: SetPreviewFieldType,
  fileName: string
): IUploadPreviewAction => ({
  type: types.UPLOAD_PREVIEW__STARTED,
  onProgress,
  setPreviewField,
  modalId,
  fileName,
})

export const previewPollingSuccess = (
  setPreviewField: SetPreviewFieldType
): IPreviewPollingSuccessAction => ({
  type: types.PREVIEW_POLLING__SUCCESS,
  setPreviewField,
})

export const previewVerificationSuccess = (): IPreviewVerificationSuccessAction => ({
  type: types.PREVIEW_VERIFICATION__SUCCESS,
})

export const deleteUploadedPreviews = (
  values
): IDeleteUploadedPreviewsAction => ({
  type: types.DELETE_UPLOADED_PREVIEWS__STARTED,
  values,
})

export const deleteUploadedPreviewsSuccess = (): IDeleteUploadedPreiewsSuccessAction => ({
  type: types.DELETE_UPLOADED_PREVIEWS__SUCCESS,
})

export const deleteUploadedPreviewsFailure = (
  message: string,
  correlationId: string
): IFailureAction => ({
  type: types.DELETE_UPLOADED_PREVIEWS__FAILURE,
  message,
  correlationId,
})
